define('controllers/consoleApi/myDashboard.ctrl',['app'], function (app) {
    app.controller('myDashboardCtrl', ['$scope', '$state', '$rootScope', '$stateParams', 'projectManageService', 'biAnalyticService', 'reportUtil','ExportExcel','auiDialog',
        function ($scope, $state, $rootScope, $stateParams, projectManageService, biAnalyticService, reportUtil,ExportExcel,auiDialog) {
            var projectKey = $stateParams.projectKey;
            var Model = $scope.Model = {
                requestType: 'line',
                errorType: 'line',
                maxType: 'line',
                //流量次数报表
                requestTimesCharts: {
                    id: "myreport.request.times",
                    width: "33%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                //错误报表
                errorTimesCharts: {
                    id: "myreport.error.times",
                    width: "33%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                //平均时延报表
                maxDelayCharts: {
                    id: "myreport.may.delay",
                    width: "33%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                query: {
                    day: 30
                },
                isHaveApi:false
            };
            $scope.applyNewApi = applyNewApi;
            $scope.changeDateType = changeDateType;
            $scope.sortApiListData = sortApiListData;

            init();

            function applyNewApi() {
                $state.go('apiList', {projectKey: Model.myProject.projectKey}, {reload: true});
            }


            function init() {
                //处理页面  分流 优化接口调用
                if (projectManageService.getProjectKey() != '0' || (projectKey && projectKey != '0')) {
                    if (projectManageService.getProjectKey() != '0' && !(projectKey && projectKey != '0')) {
                        $state.go('myDashboard', {projectKey: projectManageService.getProjectKey()}, {reload: true});
                    } else {
                        biAnalyticService.trackPageView("APIConsole - 我的信息中心页面", 'DPRM5072');
                        projectManageService.getProjectInfo({projectKey: projectKey}).then(function (data) {
                            if (data && data.projectInfo) {
                                Model.myProject = data.projectInfo;
                                Model.isHavePro =true;
                                projectManageService.setProjectKey(Model.myProject.projectKey);
                                getDashboardList();
                            }
                        });
                    }
                } else {
                    projectManageService.getProjectList().then(function (data) {
                        if (data && data.projectInfoList.length > 0) {
                            Model.projectInfoList = data.projectInfoList;
                            if (projectKey == '0' || !projectKey) {
                                Model.myProject = Model.projectInfoList[0];
                                projectManageService.setProjectKey(Model.myProject.projectKey);
                                $state.go('myDashboard', {projectKey: Model.myProject.projectKey}, {reload: true});
                            }
                        } else {
                            $state.go('myProject', {reload: true});
                        }
                    }).catch(function () {
                        $state.go('myProject', {reload: true});
                    });
                }
            }

            function getDashboardList() {
                projectManageService.getProjectAPI(Model.myProject.projectID).then(function (resp) {
                    if (resp && resp.apiInfoList && resp.apiInfoList.length > 0) {
                        Model.apiInfoList = resp.apiInfoList;
                        getApiSummaryList();
                        Model.isHaveApi = true;
                        Model.isShowPage = true;
                    } else {
                        Model.isShowPage = true;
                        Model.requestTimesCharts.options = null;
                        Model.errorTimesCharts.options = null;
                        Model.maxDelayCharts.options = null;
                    }
                });
            }

            //重新报表数据
            function getApiSummaryList() {
                projectManageService.getApiSummaryList(Model.myProject.projectID, Model).then(function (reports) {
                    reports.requestData4Excel = angular.copy(reports.requestData);
                    reports.errorData4Excel = angular.copy(reports.errorData);
                    reports.maxData4Excel = angular.copy(reports.maxData);
                    projectManageService.getApiIDToNameFilter().then(function (apiIDToNameFilter) {
                        Model.apiListData = reports.apiListData;
                        Model.isHaveData = true;
                        Model.apiIDToNameFilter = apiIDToNameFilter;
                        if (Model.apiListData.length > 3) {
                            var requestTimesIds = [];
                            var errorTimesIds = [];
                            var maxDelayIds = [];
                            //取前3条数据
                            Model.apiListData.sort(AUI.BaseJSUtil.arrObjCompare('requestTimes'));
                            var requestTimesIdsArray = angular.copy(Model.apiListData.slice(Model.apiListData.length-3));
                            Model.apiListData.sort(AUI.BaseJSUtil.arrObjCompare('errorTimes'));
                            var errorTimesIdsArray = angular.copy(Model.apiListData.slice(Model.apiListData.length-3));
                            Model.apiListData.sort(AUI.BaseJSUtil.arrObjCompare('maxDelay'));
                            var maxDelayIdsArray = angular.copy(Model.apiListData.slice(Model.apiListData.length-3));
                            requestTimesIdsArray.forEach(function (reqId) {
                                requestTimesIds.push(reqId.id);
                            });
                            errorTimesIdsArray.forEach(function (reqId) {
                                errorTimesIds.push(reqId.id);
                            });
                            maxDelayIdsArray.forEach(function (reqId) {
                                maxDelayIds.push(reqId.id);
                            });
                            reports.requestIds = angular.copy(requestTimesIds);
                            reports.errorIds = angular.copy(errorTimesIds);
                            reports.maxIds = angular.copy(maxDelayIds);
                        }

                        var requestResult = reportUtil.getXYFromBI(reports.requestData, "date", 0,
                            reports.requestIds);
                        var errorResult = reportUtil.getXYFromBI(reports.errorData, "date", 0,
                            reports.errorIds);
                        var maxResult = reportUtil.getXYFromBI(reports.maxData, "date", 0,
                            reports.maxIds);
                        if (requestResult && requestResult['date'] && requestResult['date'].length > 0) {
                            reports.requestSeries = [];
                            reports.requestIds.forEach(function (id) {
                                reports.requestSeries.push({
                                    "name": apiIDToNameFilter[id],
                                    "type": Model.requestType,
                                    "data": requestResult[id]
                                })
                            });
                            Model.requestTimesCharts.options = projectManageService.getChartOptions('流量',requestResult["date"],reports.requestSeries);
                            if(reports.requestData4Excel && reports.requestData4Excel.length>0){
                                Model.requestTimesCharts.options.toolbox.feature.myTool = {
                                    show: true,
                                    title: '下载',
                                    icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
                                    onclick: function () {
                                        downloadReport(reports.requestData4Excel,"流量")
                                    }
                                }
                            }
                        } else {
                            Model.requestTimesCharts.options = null;
                        }
                        if (errorResult && errorResult['date'] && errorResult['date'].length > 0) {
                            reports.errorSeries = [];
                            reports.errorIds.forEach(function (id) {
                                reports.errorSeries.push({
                                    "name": apiIDToNameFilter[id],
                                    "type": Model.errorType,
                                    "data": errorResult[id]
                                })
                            });
                            Model.errorTimesCharts.options = projectManageService.getChartOptions('错误数',errorResult["date"],reports.errorSeries);
                            if(reports.errorData4Excel && reports.errorData4Excel.length>0){
                                Model.errorTimesCharts.options.toolbox.feature.myTool = {
                                    show: true,
                                    title: '下载',
                                    icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
                                    onclick: function () {
                                        downloadReport(reports.errorData4Excel,"错误数")
                                    }
                                }
                            }
                        } else {
                            Model.errorTimesCharts.options = null;
                        }

                        if (maxResult && maxResult['date'] && maxResult['date'].length > 0) {
                            reports.maxSeries = [];
                            reports.maxIds.forEach(function (id) {
                                reports.maxSeries.push({
                                    "name": apiIDToNameFilter[id],
                                    "type": Model.maxType,
                                    "data": maxResult[id]
                                })
                            });
                            Model.maxDelayCharts.options = projectManageService.getChartOptions('最大时延（ms）',maxResult["date"],reports.maxSeries);
                            if(reports.maxData4Excel && reports.maxData4Excel.length>0){
                                Model.maxDelayCharts.options.toolbox.feature.myTool = {
                                    show: true,
                                    title: '下载',
                                    icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
                                    onclick: function () {
                                        downloadReport(reports.maxData4Excel,"最大时延（ms）")
                                    }
                                }
                            }
                        } else {
                            Model.maxDelayCharts.options = null;
                        }
                    });
                }).catch(function (e) {
                    Model.requestTimesCharts.options = null;
                    Model.errorTimesCharts.options = null;
                    Model.maxDelayCharts.options = null;
                    Model.apiListData=[];
                });
            }

            function downloadReport(data4Excel,name) {
                var keys= [];
                data4Excel.forEach(function (data4req) {
                    for(var k in data4req){
                        if(!AUI.BaseJSUtil.contains(keys,k)){
                            keys.push(k);
                        }
                    }
                });
                data4Excel.sort(AUI.BaseJSUtil.arrObjCompare('date'));
                data4Excel.reverse();
                var obj = {};
                keys.forEach(function (k) {
                    if(k !='date'){
                        obj[k] = Model.apiIDToNameFilter[k]
                    }else{
                        obj[k] = "时间"
                    }
                });
                data4Excel.push(obj);
                data4Excel.reverse();
                ExportExcel.data2Excel(data4Excel,name+".xlsx",name);
            }

            function changeDateType(day) {
                if (Model.query.day != day) {
                    Model.query.day = day;
                    getApiSummaryList()
                }
            }

            function sortApiListData(type) {
                if (Model.apiListData.length <= 1) return;
                if (isSort(type)) {
                    Model.apiListData.sort(AUI.BaseJSUtil.arrObjCompare(type));
                    Model.apiListData.reverse();
                } else {
                    Model.apiListData.sort(AUI.BaseJSUtil.arrObjCompare(type));
                }
            }


            //判断正序
            function isSort(type) {
                return Model.apiListData[1][type] >= Model.apiListData[0][type];
            }
        }
    ]);
});

